module.exports = __webpack_public_path__ + "img/Propiedad.be53770f.png";